import React from 'react';
import API from '../api';

export function useAuth() {
  const [authEmail, setAuthEmail] = React.useState('');
  const [authPassword, setAuthPassword] = React.useState('');
  const [user, setUser] = React.useState(() => {
    try {
      const stored = sessionStorage.getItem('auth');
      if (!stored) return null;
      const parsed = JSON.parse(stored);
      if (parsed.token) {
        API.defaults.headers.common['Authorization'] = `Bearer ${parsed.token}`;
        return parsed;
      }
      return null;
    } catch {
      return null;
    }
  });

  const initials = React.useMemo(() => {
    if (!user || !user.email) return '?';
    const namePart = user.email.split('@')[0];
    return namePart.charAt(0).toUpperCase();
  }, [user]);

  const canEdit = user && user.role === 'admin';

  // --------- AUTH handlers ---------
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!authEmail || !authPassword) {
      alert('Email et mot de passe requis');
      return;
    }
    try {
      const { data } = await API.post('/login', {
        email: authEmail,
        password: authPassword
      });
      sessionStorage.setItem('auth', JSON.stringify(data));
      API.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
      setUser(data);
      setAuthPassword('');
    } catch (err) {
      console.error(err);
      alert('Connexion impossible (vérifie email/mot de passe)');
    }
  };

  // pour bouton création viewer //
  /*
  const handleRegister = async () => {
    if (!authEmail || !authPassword) {
      alert('Email et mot de passe requis');
      return;
    }
    try {
      const { data } = await API.post('/register', {
        email: authEmail,
        password: authPassword,
        role: 'viewer'
      });
      sessionStorage.setItem('auth', JSON.stringify(data));
      API.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
      setUser(data);
      setAuthPassword('');
      alert('Compte viewer créé et connecté');
    } catch (err) {
      console.error(err);
      alert("Erreur lors de la création du compte (email déjà utilisé ?)");
    }
  };
  */

  const handleLogout = () => {
    sessionStorage.removeItem('auth');
    delete API.defaults.headers.common['Authorization'];
    setUser(null);
    setAuthEmail('');
    setAuthPassword('');
  };

  return {
    user,
    authEmail,
    setAuthEmail,
    authPassword,
    setAuthPassword,
    initials,
    canEdit,
    handleLogin,
    handleLogout
  };
}
